export default {
  // 標題
  verificationResult: "驗證結果",
  modelVerification: "模型驗證",

  // 驗證統計
  currentSuccess: "當前{count}個驗證成功；",
  hasFailed: "有{count}個驗證失敗；",
  hasNoNeed: "有{count}個是平台地址不需要模型驗證。",

  // 暫無數據
  noData: "暫無數據",

  // 加載提示
  loading: "拼命加載中",

  // 基本信息
  basicInfo: "基本信息",
  caseName: "案件名稱",
  canvasName: "畫布名稱",
  creator: "創建人",
  createTime: "創建時間",
  status: "狀態",
  verified: "已驗證",
  toBeVerified: "待驗證",
  model: "模型",
  feeModel: "手續費模型",

  // 驗證結果詳情
  verificationResultTitle: "驗證結果",
  firstFeeSourcePlatform: "首筆手續費來源平台",
  firstFeeSourceLevel: "首筆手續費來源層級",
  feeSourceLevel: "手續費來源層級",
  firstFeeSourceQuantity: "首筆手續費來源數量",
  firstFeeSourceTime: "首筆手續費來源時間",
  firstFeeSourceAddress: "首筆手續費來源地址",
  feeSourceAddress: "手續費來源地址",
  firstFeeSourceHash: "首筆手續費來源hash",
  feeSourceHash: "手續費來源hash",
  feeSourceTime: "手續費來源時間",
  feeSourceQuantity: "手續費來源數量",

  // 操作
  addToSurvey: "+加入調證",
  addToSurveySuccess: "加入調證成功",
  copySuccess: "複製成功",
  browserNotSupport: "該瀏覽器不支持自動複製",
};
